export default {
  API_BASE: 'https://rimas-versicherungskammer.de/api',
  KEEP_LOGGED_IN: true
}
